module.exports = __webpack_public_path__ + "fonts/Gilroy-Thin.b4e27db9.ttf";